import type { AutoLabelLibraryRequest } from '@/api/generatedApi';
import { GET_ASSET_QUERY_KEY } from '@/hooks/api/assets/useGetAsset';
import { LIST_ASSETS_BY_STATE_QUERY_KEY } from '@/hooks/api/assets/useFetchAssetsByState';
import { LIST_FOLDER_CONTENTS_QUERY_KEY } from '@/hooks/api/folders/useFetchFolderContents';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { getApiError } from '@/types/apiError';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const useAutoLabelLibrary = (taxonomyId: string) => {
  const queryClient = useQueryClient();
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();

  const { mutate, isPending, error, reset } = useMutation({
    mutationFn: async (data?: AutoLabelLibraryRequest) => {
      const response = await api.taxonomy.startAutoLabelLibrary(tenantId, taxonomyId, data);
      return response.data;
    },
    onSuccess: () => {
      queryClient.resetQueries({ queryKey: [LIST_FOLDER_CONTENTS_QUERY_KEY], exact: false });
      queryClient.resetQueries({ queryKey: [LIST_ASSETS_BY_STATE_QUERY_KEY], exact: false });
      queryClient.resetQueries({ queryKey: [GET_ASSET_QUERY_KEY], exact: false });
    },
  });

  return {
    startAutoLabelLibrary: mutate,
    isStartingAutoLabel: isPending,
    autoLabelStartError: getApiError(error),
    resetAutoLabelStartError: reset,
  };
};
